import { Suspense } from "react";
import { Route, Routes } from "react-router-dom";

import Loader from "./components/common/loader";
import router from "./router";

function App() {
  return (
    <Routes>
      {router.map((route, index) => (
        <Route
          key={index}
          element={
            <Suspense fallback={<Loader />}>
              <route.component />
            </Suspense>
          }
          path={route.path}
        />
      ))}
    </Routes>
  );
}

export default App;
